import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from '../../../util/withRouter';
import { Dropdown, DropdownButton, Form, Button } from 'react-bootstrap';
import CheckBox from '../../../components/Checkbox/Checkbox';

import { listAll } from '../../ReportConfig/ReportActions';

import pagination from '../../../util/pagination';
import throttle from '../../../util/throttle';

import Loading from '../../../components/Loading/Loading';
import ProgressDashboard from '../../../components/ProgressDashboard/ProgressDashboard';

import arrowSortIcon from '../../../assets/img/arrow-sort.svg';
import editIcon from '../../../assets/img/edit.svg';

// Import Style
import './ValueStreamList.scss';

export class ValueStreamList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      filter: 'all',
      sort: '-createdDate',
      search: '',
      page: 1,
      boards: [],
      sortName: [
        {
          name: 'Name: A to Z',
          value: 'name'
        },
        {
          name: 'Name: Z to A',
          value: '-name'
        }
      ],
      sortCreatedDate: [
        {
          name: 'Created date: newest first',
          value: '-createdDate'
        },
        {
          name: 'Created date: oldest first',
          value: 'createdDate'
        }
      ],
      sortUpdatedDate: [
        {
          name: 'Updated date: newest first',
          value: '-updatedDate'
        },
        {
          name: 'Updated date: oldest first',
          value: 'updatedDate'
        }
      ],
      sortAccessedDate: [
        {
          name: 'Accessed date: newest first',
          value: '-accessedDate'
        },
        {
          name: 'Accessed date: oldest first',
          value: 'accessedDate'
        }
      ]
    };

    this.getValueStreamsThrottled = throttle(this.getValueStreams, 500, this);
    this.exportCsvThrottled = throttle(this.exportCsv, 500, this);
  }

  componentDidMount() {
    this.getValueStreams();
  }

  applySort = sort => {
    this.setState({ sort, page: 1 }, this.getValueStreams);
  };

  getValueStreams = () => {
    const { search, sort, sortByName, page } = this.state;
    
    this.props.getValueStreams({ search, sort, page, id: this.props.userId });
  };

  onSearch = e => {
    this.setState({ search: e.target.value, page: 1 }, this.getValueStreamsThrottled);
  };

  goto = page => {
    if (page < 1) {
      page = 1;
    }

    this.setState({ page }, this.getValueStreams);
  };

  renderSelected = type => {
    const selected = _.find(this.state[type + 'Options'], {
      value: this.state[type]
    });
    return selected ? selected.name : '';
  };

  toggleFilter = () => {
    document.getElementById('filter-content').classList.toggle('shown');
  };

 
  renderPagination = () => {
    const pages = pagination(this.props.total, this.props.page, 20, 5);

    if (pages.totalPages < 2) {
      return <div></div>;
    }

    return (
      <ul className="pagination">
        {pages.currentPage > 1 && (
          <li aria-label="First" onClick={() => this.goto(1)}>
            <a role="button" href="#">
              «
            </a>
          </li>
        )}
        {pages.currentPage > 1 && (
          <li aria-label="Prev" onClick={() => this.goto(pages.currentPage - 1)}>
            <a role="button" href="#">
              ‹
            </a>
          </li>
        )}
        {pages.pages.map((p, i) => {
          return (
            <li className={p === pages.currentPage && 'active'} key={i} onClick={() => this.goto(p)}>
              <a role="button" href="#">
                {p}
              </a>
            </li>
          );
        })}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Next" onClick={() => this.goto(pages.currentPage + 1)}>
            <a role="button" href="#">
              ›
            </a>
          </li>
        )}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Last" onClick={() => this.goto(pages.totalPages)}>
            <a role="button" href="#">
              »
            </a>
          </li>
        )}
      </ul>
    );
  };

  render() {
    const {streams, isLoading, user } = this.props;
    const hasUserInfo = _.some(streams, stream => 
          !_.isEmpty(stream.createdBy) || !_.isEmpty(stream.updatedBy)
        );
    const title = "Select value streams";
    return (
      <React.Fragment>
        <div className="table-content">
          <div className="table-filter">
            <h5>{title}</h5>
            <div className="u-di">
              <div className="search-wrap">
                <input
                  name="search"
                  placeholder="Search"
                  type="text"
                  id="Search"
                  className="form-control"
                  value={this.state.search}
                  onChange={this.onSearch}
                />
              </div>
            </div>           
          </div>
          <div className="table-scroll">
            <table className="table">
              <thead>
                <tr>                 
                  <th>
                    <div className="flex">
                      Value Stream name
                      <Form.Group controlId="sort" className="filter-dropdown">
                        <DropdownButton
                          className="form-control-dropdown-sort"
                          id="dropdown-item-button"
                          title={<img src={arrowSortIcon} alt="#" />}
                        >
                          {this.state.sortName.map((s, i) => {
                            return (
                              <Dropdown.Item
                                key={i}
                                as="button"
                                className={this.state.sort === s.value && 'active'}
                                onClick={() => this.applySort(s.value)}
                              >
                                {s.name}
                              </Dropdown.Item>
                            );
                          })}
                        </DropdownButton>
                      </Form.Group>
                    </div>
                  </th>
                  <th>
                    <div className="flex">
                      { hasUserInfo ? 'Created by':'Created'}
                      <Form.Group controlId="sort" className="filter-dropdown">
                        <DropdownButton
                          className="form-control-dropdown-sort"
                          id="dropdown-item-button"
                          title={<img src={arrowSortIcon} alt="#" />}
                        >
                          {this.state.sortCreatedDate.map((s, i) => {
                            return (
                              <Dropdown.Item
                                key={i}
                                as="button"
                                className={this.state.sort === s.value && 'active'}
                                onClick={() => this.applySort(s.value)}
                              >
                                {s.name}
                              </Dropdown.Item>
                            );
                          })}
                        </DropdownButton>
                      </Form.Group>
                    </div>
                  </th>
                  <th>
                    <div className="flex">
                     { hasUserInfo ? 'Updated by':'Updated'}
                      <Form.Group controlId="sort" className="filter-dropdown">
                        <DropdownButton
                          className="form-control-dropdown-sort"
                          id="dropdown-item-button"
                          title={<img src={arrowSortIcon} alt="#" />}
                        >
                          {this.state.sortUpdatedDate.map((s, i) => {
                            return (
                              <Dropdown.Item
                                key={i}
                                as="button"
                                className={this.state.sort === s.value && 'active'}
                                onClick={() => this.applySort(s.value)}
                              >
                                {s.name}
                              </Dropdown.Item>
                            );
                          })}
                        </DropdownButton>
                      </Form.Group>
                    </div>
                  </th>                 
                </tr>
              </thead>
              <tbody>
                {streams.map((d, i) => {
                  return (
                    <tr key={i}>                      
                      <td>
                        {this.props.selectable ? (                        
                            <CheckBox
                                id={d._id}
                                name={d._id}
                                label={d.name}     
                                onChange={this.props.handleChange}                          
                                checked={this.props.selected.indexOf(d._id) > -1}
                              />
                        )
                        :
                        (!d.label || d.label == d.name) ? (
                          <p>{d.name}</p>
                        ) : (
                          <React.Fragment>
                            <p>{d.label}</p>
                            <p>{d.name}</p>
                          </React.Fragment>
                        )}
                      </td>
                      <td>
                        {d.createdBy ? (
                          <React.Fragment>
                            <p>{d.createdBy.name}</p>
                            <p>{d.createdBy.email}</p>                            
                            <p>{d.createdAt ? moment(d.createdAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                          </React.Fragment>
                        ) : (
                           <p>{d.createdAt ? moment(d.createdAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                        )}
                      </td>
                      <td>
                        {d.updatedBy ? (
                          <React.Fragment>
                            <p>{d.updatedBy.name}</p>
                            <p>{d.updatedBy.email}</p>                           
                            <p>{d.updatedAt ? moment(d.updatedAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                          </React.Fragment>
                        ) : (
                           <p>{d.updatedAt ? moment(d.updatedAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>      

        {isLoading && (
          <div className="table-loading">
            <Loading />
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {    
    getValueStreams: opt => dispatch(listAll())
  };
};

const mapStateToProps = state => {
  return {
    streams: state.report.streams,   
    user: state.auth.user
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ValueStreamList));
